module.exports = __webpack_public_path__ + "static/media/GLOSSADSK.145b787e.txt";